// extracted by mini-css-extract-plugin
module.exports = {"costWrapper":"costVisualizer_costWrapper__39KvP","costText":"costVisualizer_costText__ygFDi"};